import { render } from "./VideoSection5.vue?vue&type=template&id=edf352ee"
import script from "./VideoSection5.vue?vue&type=script&lang=js"
export * from "./VideoSection5.vue?vue&type=script&lang=js"

import "./VideoSection5.vue?vue&type=style&index=0&id=edf352ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__